export default "__VITE_ASSET__ec9053e4__$_?nuxt_component=async__"